import api, { webApi, getCsrfToken } from "../api";

export const getNotifications = async () => {
  const res = await api.get("/notifications");
  return res.data;
};

export const sendNotification = async (payload: {
  title: string;
  body: string;
}) => {
  await getCsrfToken();
  const res = await webApi.post(`/admin/notifications/send`, payload);
  return res.data;
};

export const getNotificationLogs = async () => {
  const res = await webApi.get(`/admin/notifications/logs`);
  return res.data;
};

export default { getNotifications, sendNotification, getNotificationLogs };
